<template>
	<div style="display: inline-block; width: 100%">
	  <!-- 内部新增搜索框的策略 -->
	  <el-input
		class="selectClass"
		:placeholder="inputPlaceholder"
		readonly
		v-model="lstUserName"
		v-popover:choseAgentPopover
		v-if="lstUserName && lstUserName != ''"
	  >
		<span class="el-input__suffix" slot="suffix">
		  <span class="el-input__suffix-inner">
			<i
			  @click.stop="clearSelect"
			  class="el-icon-circle-close"
			  style="position: absolute;left: -16px;top: 14px;background-color: #ffffff;width: 20px;"
			></i>
			<i
			  class="el-select__caret el-input__icon el-icon-arrow-down"
			  :class="{
				'is-reverse': showAgentDropDown
			  }"
			></i>
		  </span>
		</span>
	  </el-input>
	  <el-input
		class="selectClass"
		:placeholder="inputPlaceholder"
		readonly
		v-model="lstUserName"
		v-popover:choseAgentPopover
		v-else
	  >
		<span class="el-input__suffix" slot="suffix">
		  <span class="el-input__suffix-inner">
			<i
			  class="el-select__caret el-input__icon el-icon-arrow-down"
			  :class="{
				'is-reverse': showAgentDropDown
			  }"
			></i>
		  </span>
		</span>
	  </el-input>
	  <el-popover
		popper-class="agentself-popover"
		placement="bottom-start"
		ref="choseAgentPopover"
		trigger="click"
		@show="showAgentDepartmentPopover"
		@hide="hideAgentDepartmentPopover"
		:visible-arrow="false"
	  >
		<div style="background-color: #ffffff">
		  <!-- <el-input class="keyword-search" :placeholder="searchPlaceholder">
		  </el-input> -->
		  <div class="scrollbar-wrapper">
			<!-- 内部文本-->
			<el-tree
			  :data="dataList"
			  show-checkbox
			  @check-change="handleCheckChange"
			  node-key="id"
			  ref="userNameTree"
			  :filter-node-method="filterNode"
			>
			</el-tree>
		  </div>
  
		  <el-input
			placeholder="请输入关键字过滤"
			v-model="filterText"
		  ></el-input>
		</div>
	  </el-popover>
	</div>
  </template>
  
  <script>
  import { getUserTree } from "@/api/basicApi.js";
  
  export default {
	data() {
	  return {
		filterAgentTextClass: "",
		agentTreeData: [],
		showAgentDropDown: false,
		lstUserName: "",
		lstUserId: [],
		radios: [],
		dataList: [],
		filterText: ""
	  };
	},
	props: {
	  isShowLabel: {
		type: Boolean,
		default: false
	  },
	  inputPlaceholder: {
		type: String,
		default: "请选择用户"
	  },
	  isSingleChoice: {
		type: Boolean,
		default: false
	  },
	  doClear: {
		type: Boolean,
		default: false
	  }
	},
	watch: {
	  filterText(val) {
		this.$refs.userNameTree.filter(val);
	  },
	  doClear(newVal, oldVal) {
		this.clearSelect();
	  }
	},
	methods: {
	  filterNode(value, data) {
		if (!value) return true;
		return data.label.indexOf(value) !== -1;
	  },
	  handleCheckChange(data) {
		console.log(data);
	  },
	  async initData() {
		let res = await getUserTree({isAll:1});
		let result = [];
		result = res.data.map(e => {
		  if (e.childList) {
			let tempList = e.childList.map(e2 => {
			  return {
				id: e2.id,
				label: e2.userName,
				children: e2.childList
			  };
			});
			return {
			  id: e.id,
			  label: e.userName,
			  children: tempList
			};
		  } else {
			return {
			  id: e.id,
			  label: e.userName,
			  children: e.childList
			};
		  }
		});
		console.log("el-tree", result);
		this.dataList = result;
	  },
	  showAgentDepartmentPopover() {
		this.showAgentDropDown = true;
	  },
	  hideAgentDepartmentPopover() {
		this.showAgentDropDown = false;
		this.lstUserId = []; //置空一下
		this.lstUserName = "";
		let selectPeopleName = [];
		let selectPeopleId = [];
		let selectIdArr = this.$refs.userNameTree.getCheckedKeys();
		let selectNodeArr = this.$refs.userNameTree.getCheckedNodes();
		console.log(selectIdArr);
		console.log(selectNodeArr);
		if (selectNodeArr.length > 0) {
		  selectNodeArr.map(item => {
			let arr = item.id.split("_");
			if (arr.length < 2) {
			  selectPeopleName.push(item["label"]);
			}
		  });
			selectIdArr.map(item => {
			  let arr = item.split("_");
			  if (arr.length < 2) {
				selectPeopleId.push(item);
			  }
			});
		  this.lstUserName = selectPeopleName.join(",");
		  this.lstUserId = selectPeopleId;
		  this.$emit("input", this.lstUserId); //必须在前面
		  this.$emit("select", this.lstUserId);
		} else {
		  this.lstUserName = "";
		  this.lstUserId = [];
		  this.$emit("input", []); //必须在前面
		  this.$emit("select", []); //为了清空
		}
	  },
	  clearSelect() {
		this.$refs.userNameTree.setCheckedNodes([]);
		this.hideAgentDepartmentPopover();
		this.lstUserName = "";
	  }
	  // monitoring() {
	  //   // 监听事件
	  //   this.$on("clearSelect", res => {
	  //     this.$refs.userNameTree.setCheckedNodes([]);
	  //   });
	  // },
	},
	mounted() {
	  this.initData();
	  // this.monitoring(); // 注册监听事件
	}
  };
  </script>
  
  <style lang="scss" scoped>
  .is-reverse {
	transform: rotate(-180deg);
  }
  
  .selectClass {
	width: 90%;
  
	:deep(.el-input__inner) {
	  height: 32px;
	}
  }
  
  .scrollbar-wrapper {
	background-color: #ffffff;
	max-height: 250px;
	overflow: auto;
	padding-right: 10px;
	margin-bottom: 10px;
	// .el-scrollbar__wrap {
	//   margin-bottom: -30px !important;
	// }
  }
  </style>
  <style lang="scss">
  .agentself-popover {
	max-height: 300px;
	overflow-y: auto;
	.el-tree-node__label {
	  font-size: 12px;
	  overflow-y: auto;
	}
	&:has(.is-expanded) {
	  width: auto !important;
	  .el-tree-node__content {
		transition: all 0 ease-out;
	  }
	}
  }
  </style>
  